module.exports = __webpack_public_path__ + "img/pencil-alt-attached.78b16c9.png";